import { render, staticRenderFns } from "./sportsFollow.vue?vue&type=template&id=4883c3ec&scoped=true&"
import script from "./sportsFollow.vue?vue&type=script&lang=js&"
export * from "./sportsFollow.vue?vue&type=script&lang=js&"
import style0 from "./sportsFollow.vue?vue&type=style&index=0&id=4883c3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883c3ec",
  null
  
)

export default component.exports